module.exports = addHttpFilter;

/*@ngInject*/
function addHttpFilter($filter) {
    return function(url) {
        if (!url) return '';

        const httpPrefix = 'http://';
        const httpsPrefix = 'https://';
        if (url.substr(0, httpPrefix.length) !== httpPrefix && url.substr(0, httpsPrefix.length) !== httpsPrefix) {
            return httpPrefix + url;
        }
        return url
    };
}



/** WEBPACK FOOTER **
 ** ./app/shared/filters/addHttp.filter.js
 **/